<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <div class="row">
          <label class="col-sm-2 col-form-label">제목(목록용)</label>
          <div class="col-sm-10">
            <base-input placeholder="제목" v-model="title">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">카테고리명</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-12">
                <base-input placeholder="제목" v-model="name">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <base-input placeholder="제목(영어)" v-model="nameEn">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <base-input placeholder="제목(일본어)" v-model="nameJa">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </card>
      <base-button native-type="submit" v-if="id != null" type="success">수정</base-button>
      <base-button native-type="submit" v-else type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import { Toast } from "@/util/Toast";

export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    this.unitId = Number(this.$route.query.unitId);
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getCategoryById();
    }
  },
  data() {
    return {
      unitId: null,
      id: null,
      title: null,
      name: null,
      nameEn: null,
      nameJa: null,
    };
  },
  methods: {
    async getCategoryById() {
      const res = await this.$axios.get(`/quests/categories/${this.id}`);
      const data = res.data.data;
      this.title = data.title;
      this.name = data.name;
      this.nameEn = data.nameEn;
      this.nameJa = data.nameJa;
    },
    async onSubmit() {
      if (!this.title) {
        Toast.error("제목을 입력해주세요");
        return;
      }

      const params = {
        unitId: this.unitId,
        title: this.title,
        name: this.name,
        nameEn: this.nameEn,
        nameJa: this.nameJa,
      };
      try {
        if (this.id) {
          await this.$axios.put(`/quests/categories/${this.id}`, params).then(() => {
            Toast.success("수정되었습니다");
            this.$router.go(-1);
          });
        } else {
          await this.$axios.post(`/quests/categories`, params).then(() => {
            Toast.success("등록되었습니다");
            this.$router.go(-1);
          });
        }
      } catch (e) {
        Toast.error("저장중 에러발생");
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
.custom-col {
  max-width: 20%;
  flex: 0 0 20%;
}
</style>
